export default [
  {
    title: 'Introduction',
    details: [
      {
        description:
          'The Schedulized Platform is a created and controlled by Redelec Services Pty Ltd (ACN 614 350 613) (<b>we</b>, <b>us</b> or <b>our</b>). The purpose of the Schedulized Platform is to allow electricians and building service maintenance providers to download, access, amend and update building electrical information in real time. '
      },
      {
        description:
          'By accessing and using the Schedulized Platform, you agree to comply with the terms of this this privacy policy (<b>Privacy Policy</b>). This Privacy Policy outlines how we collect, store, use and disclose your Personal Information, and how you may access your Personal Information (as defined in the Privacy Act) kept by us or how you may make a privacy complaint.'
      },
      {
        description:
          'Personal information will be handled and collected from you in accordance with the Australian Privacy Principles set out in the Privacy Act 1988 (Cth) (<b>Privacy Act</b>).'
      }
    ]
  },
  {
    title: 'The information we collect about you',
    details: [
      {
        description:
          'We will only collect and hold Personal Information about you that is reasonably necessary to undertake our business activities and functions, deliver the Schedulized Platform (and our other products and services) to you, or as otherwise permitted by law.'
      },
      {
        description:
          'The type of Personal Information that we collect and use depends on the type of dealings that you have with us and includes the following:',
        details: [
          'your contact details (for example, full name, address, mobile and telephone numbers and email address);',
          'service provider information (for example, building practitioner or service provider ID, business address, work mobile, business number, and work email address);',
          'project or site related information (for example, name and addresses of owner occupiers); ',
          'user account information (for example, usernames, passwords, pseudonyms and nicknames); ',
          'employment related information (for example, resume or CV details); ',
          'payment and billing information, such as credit or debit card information;',
          'information regarding your access and use of our App, including location information, your device’s internet protocol (IP) address, unique device identifier, browser characteristics, device characteristics, operating system, language preferences, URL preferences, information on actions taken on your App, the date and times of visits to our App and other usage statistics; and ',
          'other information that you provide to us or that we may collect in the course of our relationship with you.'
        ]
      },
      {
        description:
          'We do not collect your Sensitive Information (as defined by the Privacy Act).'
      }
    ]
  },
  {
    title: 'How we collect Personal Information',
    details: [
      {
        description:
          'We will collect Personal Information about you in a number of different ways. We may collect Personal Information directly from you, or in the course of our dealings with you. For example:',
        details: [
          'when you download, access and use the Schedulized Platform, including to access or input project or site, building or project related information or data; ',
          'when you contact and correspond with us or make a general enquiry about the Schedulized Platform or our other products or services (for example, when you complete online forms or subscribes to our publications, alerts and newsletters, or information you provide to us when you send us an email);',
          'when you visit our website (including via cookies), contact us online or via telephone or email with a query or request, or make a comment on our social media sites (for example, Facebook and LinkedIn);',
          'when you provide your Personal Information to third parties (including to our related bodies corporate, business partners, listing agents, referral partners, referral agents, service providers, credit reporting bodies, credit providers, government agencies, public registries, search agencies, regulatory and licensing bodies, parties to whom you refer us (for example, previous employers and referees), recruitment agencies and from publicly available sources of information (for example, online databases and social media)) (collectively,  <b>Third Party Providers</b>); ',
          'when you apply for a position or employment with us; ',
          'from publicly available sources of information; or',
          'when otherwise legally authorised or required to do so.'
        ]
      },
      {
        description:
          'When we collect Personal Information directly from you, we will take reasonable steps to notify you (using a collection notice) at, before, or as soon as practicable after, the time of collection.'
      }
    ]
  },
  {
    title: 'How we use your Personal Information',
    details: [
      {
        description:
          'We use and disclose your Personal Information, including, but not limited, to:',
        details: [
          'providing users with access to, and use of, the Schedulized Platform and our other products or services;',
          'provide you with technical IT access and support in relation to the use of our Schedulized Platform;',
          'manage the function and utility of the Schedulized Platform, including any upgrades and new releases of the Schedulized Platform; ',
          'manage any licences and storage of project or project related data on or through the Schedulized Platform',
          'inform you about upgrades to the Schedulized Platform (and our other goods and services) and any matters which we believe are of interest to;',
          'share with our Third Party Pr oviders;',
          'administering, improving and managing the Schedulized Platform, our products and services (including customising the advertising and content on the Schedulized Platform), our relationship with users ',
          'charge and bill you for the use of the Schedulized Platform (and our other goods and services);',
          'for direct marketing purposes; and',
          'comply with our legal and regulatory obligations.'
        ]
      }
    ]
  },
  {
    title: 'How we use your Personal Information',
    details: [
      {
        description:
          'We use and disclose your Personal Information, including, but not limited, to:',
        details: [
          'providing users with access to, and use of, the Schedulized Platform and our other products or services;',
          'provide you with technical IT access and support in relation to the use of our Schedulized Platform;',
          'manage the function and utility of the Schedulized Platform, including any upgrades and new releases of the Schedulized Platform; ',
          'manage any licences and storage of project or project related data on or through the Schedulized Platform',
          'inform you about upgrades to the Schedulized Platform (and our other goods and services) and any matters which we believe are of interest to;',
          'share with our Third Party Pr oviders;',
          'administering, improving and managing the Schedulized Platform, our products and services (including customising the advertising and content on the Schedulized Platform), our relationship with users ',
          'charge and bill you for the use of the Schedulized Platform (and our other goods and services);',
          'for direct marketing purposes; and',
          'comply with our legal and regulatory obligations.'
        ]
      }
    ]
  },
  {
    title: 'Disclosure to Third Parties',
    details: [
      {
        description:
          'In order to provide you with use and access to the Schedulized Platform, you we may disclose your Personal Information to:',
        details: [
          'our Third Party Providers; ',
          'our professional advisers such as lawyers, accountants, financial advisers, and insurers;  ',
          'the person or entity who has authorised you to access and use Schedulized Platform;',
          'developers, project managers, IT support professionals and helpdesks, cloud providers, data hosting platforms, and investors;',
          'government, or law enforcement bodies to assist with their law enforcement functions; or ',
          'or as otherwise required or authorised by law.'
        ]
      },
      {
        description:
          'Prior to the disclosure of Personal Information to Third Party Providers, we will take such steps as reasonable in the circumstances to ensure that the Third Party Providers treat your Personal Information securely, and otherwise complies with the relevant Australian Privacy Principles in relation to the Personal Information.'
      }
    ]
  },
  {
    title: 'Marketing communications',
    details: [
      {
        description:
          'We may use and disclose your Personal Information to send you information about the products or services we offer, as well as other information that may be of interest to you. We may send this information in a variety of ways, such as by mail, email, SMS, telephone, social media or by customising online content and displaying advertising on our or through the Schedulized Platform'
      },
      {
        description:
          'If you do not wish to receive any of these marketing communications, you can opt out by following the unsubscribe instructions included in the relevant marketing communication, or by contacting us using the contact details set out in section 12 below. '
      }
    ]
  },
  {
    title: 'Overseas disclosures of Personal Information',
    details: [
      {
        description:
          'In the course of providing you with the Schedulized Platform and our other products or services, it may become necessary or desirable to disclose Personal Information to Third Party Providers located overseas. The countries in which these overseas recipients may be located will depend upon the individual circumstances. However, in the course of our ordinary business operations we commonly disclose Personal Information to Third Party Providers located in the following countries: [insert].'
      },
      {
        description:
          'The laws where these overseas recipients may be located provide various levels of protection for Personal Information which are not always equivalent to the level of protection that may be provided for in Australia. Where we transfer your Personal Information overseas we will take reasonable steps to ensure that your Personal Information is treated securely and the means of transfer provides adequate safeguards.'
      }
    ]
  },
  {
    title: 'Notifiable Data Breaches Scheme',
    description:
      'In the event of any loss, or unauthorised access or disclosure of your Personal Information that is likely to result in serious harm to you, we will investigate and notify you and the Australian Information Commissioner as soon as practicable, in accordance with notifiable data breach scheme contained in Part IIIC of the Privacy Act.'
  },
  {
    title: 'Security of your Personal Information ',
    details: [
      {
        description:
          'We take steps reasonable in the circumstances to ensure that the Personal Information it holds is protected from misuse, interference and loss and from unauthorised access, modification or disclosure. '
      },
      {
        description:
          'The transmission of information via the Internet is not completely secure. We cannot guarantee the security of your data transmitted to our online services and any transmission is at your own risk. '
      },
      {
        description:
          'We will destroy or de-identify Personal Information in circumstances where it is no longer required, unless we are otherwise required or authorised by law to retain the information.'
      }
    ]
  },
  {
    title: 'Accessing and correcting your Personal Information',
    details: [
      {
        description:
          'We take steps reasonable in the circumstances to ensure Personal Information we hold is accurate, up-to-date, complete, relevant and not misleading. Under the Privacy Act, you have a right to access and seek correction of your Personal Information that is collected and held by us.'
      },
      {
        description:
          'If at any time you would like to access or correct the Personal Information we hold about you, or you would like more information about our approach to privacy, please contact us via the contact details set out in section 12 below. If we refuse your request to access or correct your Personal Information, we will provide you with written reasons for the refusal and details of complaint mechanisms. '
      }
    ]
  },
  {
    title: 'Cookies',
    description:
      'We use small text files placed on your computer called ‘cookies’ to collect standard log and visitor behaviour information in an anonymous form. We use this information to analyse how visitors use our website and to compile statistical reports on website activity. You can set your computer to reject cookies, but this may affect your ability to use certain parts of our website. '
  },
  {
    title: 'Privacy complaints',
    description:
      'If you have any complaints or issues you wish to raise with us regarding the way we have handled your Personal Information, or would like to discuss any issues about our Privacy Policy, please contact us directly by:',
    details: [
      {
        description: 'email at [insert]; or'
      },
      {
        description: 'calling us on [insert].'
      }
    ]
  },
  {
    title: 'Changes to this Privacy Policy',
    description:
      'From time to time it may be necessary for us to review and revise our Privacy Policy. We may notify you about changes to this Privacy Policy by posting an updated version on our website. We encourage you to check our website from time to time to ensure you are familiar with our latest Privacy Policy.'
  }
]
